import { render, staticRenderFns } from "./APIUsage.vue?vue&type=template&id=0facaae9&scoped=true&"
import script from "./APIUsage.vue?vue&type=script&lang=js&"
export * from "./APIUsage.vue?vue&type=script&lang=js&"
import style0 from "./APIUsage.vue?vue&type=style&index=0&id=0facaae9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0facaae9",
  null
  
)

export default component.exports